import { useAppDispatch } from "./useApp";
import { KeyboardState, showKeyboard } from "store/slices/keyboardSlice";

export const useShowKeyboard = () => {
    const dispatch = useAppDispatch();
    return (state: KeyboardState) => dispatch(showKeyboard(state));
}